module.exports = __webpack_public_path__ + "img/20.e7298fae.jpg";